/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/HeaderLanding';
import Element from '../../components/element';
import { colors } from '../../config/theme';
import Flex from '../../components/flex';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveAssessment } from '../../root/actions';
import GradientDivider from '../../components/gradientDivider';
import Errorpage from '../../components/ErrorPage';
import { ReactComponent as Burger } from '../../assets/icons/Burger.svg';
import AppLogout from '../../utils/AppLogout';
import useToast from '../../components/Toast/useToast';

const getReduxData = state => {
  return {
    user: state.containers.app.get('user')
  };
};
const getErrorStatus = state => {
  return state.api.get('hasError');
};

const PatientLanding = () => {
  const dispatch = useDispatch();
  const data = useSelector(getReduxData);
  const appHasError = useSelector(getErrorStatus);
  const navigate = useNavigate();
  const { user } = data;
  const [sideNavOpen, setSideNavOpen] = useState(false);
  const [openSnackbar] = useToast()

  const goToSurvey = survey => {
    if (user.dob) {
      dispatch(setActiveAssessment(survey));
      setSideNavOpen(false);
      navigate(`/landing/assessments/${survey.shortName}`);
    } else {
      openSnackbar('Please update profile details to proceed with this.', 'warn')
    }
  };

  const openSideNav = () => {
    setSideNavOpen(!sideNavOpen);
  };

  return (
    <Element backgroundColor={colors.white}>
      <AppLogout />
      <Flex>
        <Element className="leftPanelRes">
          <Element>
            <Element
              type={Burger}
              cursor="pointer"
              width="180px"
              height="30px"
              onClick={openSideNav}
              className="navIcon"
            />
          </Element>
          {/* <Element className={sideNavOpen ? 'openSideNav' : 'closeSideNav'}> */}
          <Sidebar
            onSurveyClick={goToSurvey}
            className={sideNavOpen ? 'openSideNav' : 'closeSideNav'}
          ></Sidebar>
          {/* </Element> */}
        </Element>
        <Element
          className="rightPanelRes"
          onClick={() => {
            setSideNavOpen(false);
          }}
        >
          <Header user={user} />
          <Element padding="0px 40px">
            <Element type={GradientDivider} marginTop="0px" />
            {appHasError ? <Errorpage mode="default" /> : <Outlet />}
          </Element>
        </Element>
      </Flex>
    </Element>
  );
};

export default PatientLanding;
